//Theme Scripts

// Fixed navigation

document.addEventListener('DOMContentLoaded', function() {
  const navbar = document.querySelector(".fixed");

  // Suoritetaan vain jos fixed-elementti löytyy
  if (navbar) {
    let prevScrollPos = window.scrollY;
    const scrollThreshold = 800;
    const colorThreshold = 1;

    window.onscroll = function() {
      let currentScrollPos = window.scrollY;

      if (prevScrollPos > currentScrollPos || currentScrollPos < scrollThreshold) {
        navbar.style.top = "0";
      } else {
        navbar.style.top = `-${navbar.offsetHeight}px`;
      }

      if (currentScrollPos >= colorThreshold) {
        navbar.classList.add("scrolled");
      } else {
        navbar.classList.remove("scrolled");
      }

      prevScrollPos = currentScrollPos;
    };
  }
});